module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 32 32\">\n    <path class=\"accent-fill\" d=\"M18.824 19.733v9.334H32v-9.334H18.824zM30.902 27.9h-10.98v-7h10.98v7zm-7.373 1.167h4.706V30H23.53v-.933zM0 29.067h13.176v-9.334H0v9.334zM1.098 20.9h10.98v7H1.098v-7zm3.608 8.167h4.706V30H4.706v-.933zM22.588 2H9.412v9.333h13.176V2zm-1.098 8.167H10.51v-7h10.98v7zm-7.372 1.166h4.706v.934h-4.706v-.934z\"/>\n    <path class=\"secondary-fill\" d=\"M7.15 16.92h18.41v1.68h1.15v-2.8h-9.78V13h-1.15v2.8H6v2.8h1.15z\"/>\n</svg>\n"


//////////////////
// WEBPACK FOOTER
// /www/client/src/components/Icon/network.svg
// module id = 316
// module chunks = 0